module["exports"] = [
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{male_first_name} #{last_name}",
  "#{female_first_name} #{last_name}"
];